// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"336":"c6473e86e26e2f76","606":"eb0825c1e1e87d73","818":"3737c4d077beeaca"}[chunkId] + ".js";
};